import BrandsContext from 'contexts/brandsContext';
import React, { useContext } from 'react';

const useBrands = () => useContext(BrandsContext);
 
export default useBrands;